<script>
    import { onMount } from 'svelte';

    import StepsBar from "./components/StepsBar.svelte";
    import Questions from "./components/Questions.svelte";
    import { answers } from './store';
    import Finish from "./components/Finish.svelte";

    export let category = "";
    export let description = "";
    export let finish = "";
    export let title = "";

    let questions = [];
    let question;
    let step = 1;

    answers.subscribe(value => {
        step = Object.keys(value).length + 1;
        question = questions[step - 1];
        if (question && question.taxonomy !== "product_cat") {
            question.result = [];
            getQuestionOptions(question, value).then((results) => {
                question.result = results;
            });
        }
    });

    function goBack() {
        question = questions[step - 2];
        let tempAnswers = {};
        const temp = $answers;

        Object.keys(temp).forEach(key => {
            if (key === question.name) {
                delete temp[key]
                console.log(question);
                if (question.preset === false && question.include.length === 0) {
                    question.result = []
                }
            }
        })

        tempAnswers = temp;
        answers.set(tempAnswers);
    }

    onMount(async () => {
        questions = await fetchQuestions();
        question = questions[step - 1];
    });

    async function getQuestionOptions(question, answers) {
        try {
            const response = await fetch(`${window.digi_configurator_object.rest_url}/configurator/${category}/${question.taxonomy}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    answers: answers
                })
            });

            if (response.ok) {
                return await response.json();
            } else {
                new Error(`${response.status} ${response.statusText}`)
            }
        } catch (e) {
            console.error(e)
        }
    }

    async function fetchQuestions() {
        try {
            const response = await fetch(`${window.digi_configurator_object.rest_url}/configurator/${category}`);

            if (response.ok) {
                return await response.json();
            } else {
                new Error(`${response.status} ${response.statusText}`)
            }
        } catch (e) {
            console.error(e)
        }
    }
</script>

<div class="dg-configurator">
    <div class="dg-wrapper">
        {#if step === (questions.length + 1) && questions.length !== 0}
            <Finish category={category} description={finish} answers={$answers} />
        {:else}
            <h2>{title}</h2>
            {@html description}

            <StepsBar active={step} length={questions.length} />
            <Questions on:back={goBack} step={step} question={question} isFinal={questions[step] === undefined} />
        {/if}
    </div>
</div>

{#if step === (questions.length + 1) && questions.length !== 0}
    <div class="retry-wrapper">
        <button class="button retry" on:click={() => window.location.reload()}>
            Start de keuzehulp opnieuw
        </button>
    </div>
{/if}

<style lang="scss">
    .retry {
        margin-top: 35px;
        border: 2px solid #979797;
        border-radius: 5px;
        background: transparent;
        color: #979797;
        text-transform: lowercase;
        letter-spacing: normal;
        display: flex;
        justify-content: space-between;
        align-items: center;


        &::after {
            content: '';
            display: block;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC42MjEiIGhlaWdodD0iMTguMjQzIiB2aWV3Qm94PSIwIDAgMTAuNjIxIDE4LjI0MyI+PHBhdGggZD0iTTAsMCw3LDcsMCwxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4xMjEgMi4xMjEpIiBmaWxsPSJub25lIiBzdHJva2U9IiM5Nzk3OTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMiLz48L3N2Zz4=);
            width: 7px;
            height: 14px;
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: 15px;
        }

        &-wrapper {
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }

    .dg-configurator {
        width: 100%;
    }

    .dg-configurator :global(button) {
        background: #25CB01;
        color: #fff;
        font-size: 14px;
        text-transform: initial;
        letter-spacing: normal;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &::after {
            content: '';
            display: block;
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC42MjEiIGhlaWdodD0iMTguMjQzIiB2aWV3Qm94PSIwIDAgMTAuNjIxIDE4LjI0MyI+PHBhdGggZD0iTTAsMCw3LDcsMCwxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4xMjEgMi4xMjEpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMiLz48L3N2Zz4=");
            width: 7px;
            height: 14px;
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: 15px;
        }
    }

    .dg-configurator :global(button.back) {
        border: 2px solid #979797;
        border-radius: 5px;
        background: transparent;
        color: #979797;
        letter-spacing: normal;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 15px;

        &::before {
            content: '';
            display: block;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC42MjEiIGhlaWdodD0iMTguMjQzIiB2aWV3Qm94PSIwIDAgMTAuNjIxIDE4LjI0MyI+PHBhdGggZD0iTTAsMCw3LDcsMCwxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4xMjEgMi4xMjEpIiBmaWxsPSJub25lIiBzdHJva2U9IiM5Nzk3OTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMiLz48L3N2Zz4=);
            width: 7px;
            height: 14px;
            background-size: contain;
            background-repeat: no-repeat;
            margin-right: 15px;
            transform: rotate(180deg);
        }

        &::after {
            content: unset;
        }
    }

    .dg-wrapper {
        width: 85%;
        margin: 0 auto;
        border: 1px solid #0D78B7;
        box-shadow: 0 0 30px 3px rgba(0, 0, 0, 0.31);
        border-radius: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 50px 35px;

        :global(h2) {
            font-size: 30px;
            font-weight: bold;
            color: #0D78B7;
            text-transform: uppercase;
        }


        :global(p) {
            text-align: center;
        }
    }
</style>
